import { createReducer, on } from '@ngrx/store';
import { Project } from '../../models/dbmodels';
import { EventLogViewModel, ProjectSearchRequest } from '../../models/viewmodels';
import { PricingInputRequest, PricingInputResponse } from 'src/app/models/pricing-view-models';
import {
  loadPricingInputsFailure,
  searchPricingInputsSuccess,
  updatePricingInputsSearchRequest,
} from './pricing-inputs.actions';

export interface PricingInputsState {
  pricingInputResponse: PricingInputResponse;
  pricingInputRequest: PricingInputRequest;
}

export const initialPricingInputsState: PricingInputsState = {
  pricingInputResponse: {} as PricingInputResponse,
  pricingInputRequest: {} as PricingInputRequest
};

export const pricingInputsFeatureKey = 'pricingInputsState';

export const pricingInputsReducer = createReducer(
  initialPricingInputsState,
  on(searchPricingInputsSuccess, (state, { pricingInputRequest, pricingInputResponse }): PricingInputsState => {
    return {
      ...state,
      pricingInputRequest: pricingInputRequest,
      pricingInputResponse: pricingInputResponse
    };
  }),
  on(updatePricingInputsSearchRequest, (state, { pricingInputRequest }): PricingInputsState => {
    return {
      ...state,
      pricingInputRequest
    };
  }),
  on(loadPricingInputsFailure, (state, { error }): PricingInputsState => {
    console.error(error);
    return state;
  }),
);
